module.exports = __webpack_public_path__ + "img/take-away-small.7bec6696.svg";